export default __webpack_public_path__ + "static/media/6th Strongest Passport.193423ab.svg";